import { render, staticRenderFns } from "./SnackbarWrapper.vue?vue&type=template&id=8d589b5e&scoped=true&"
import script from "./SnackbarWrapper.vue?vue&type=script&lang=ts&"
export * from "./SnackbarWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SnackbarWrapper.vue?vue&type=style&index=0&id=8d589b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d589b5e",
  null
  
)

export default component.exports